import RefreshIcon from "@mui/icons-material/Refresh";
import LaunchIcon from "@mui/icons-material/Launch";
import { Button, Stack, Typography } from "@mui/material";
import GlobusPersonalShareGuide from "../../download-tools/components/GlobusPersonalShareGuide";
import { SolutionDetails } from "../GlobusErrorsSolutions";

type GlobusEmptyCollectionErrorProps = {
    content: SolutionDetails
}

const openGlobusShare = () => {
    window.open(window.env.globus.connect_personal_url, "_blank", "noopener, noreferrer");
}

const GlobusEmptyCollectionError = (props: GlobusEmptyCollectionErrorProps) => {
    const { content } = props;
    return (
        <Stack gap={3} padding={'1rem'}>
            <Typography fontWeight="bolder" fontSize={'2rem'} >
                {content.title}
            </Typography>
            <Stack flexDirection="row" alignItems="center" gap={4}>
                <Typography fontWeight="600">
                    {content.subtitle}
                </Typography>

                <Button 
                    variant="secondary"
                    endIcon={<LaunchIcon />}
                    onClick={openGlobusShare}
                >
                    Learn More
                </Button>
            </Stack>
            <GlobusPersonalShareGuide/>
            <Stack flexDirection="row" alignItems="center" gap={4}>
                <Typography fontWeight="600">
                    Once these steps have been completed, you can see your collections on this page and continue downloading data.
                </Typography>

                <Button variant="secondary" startIcon={<RefreshIcon />}
                    onClick={() => window.location.reload()}>
                    Refresh
                </Button>
            </Stack>
        </Stack>
    );
}

export default GlobusEmptyCollectionError;